import { render, staticRenderFns } from "./BuyerOrder.vue?vue&type=template&id=47fdaace&scoped=true&"
import script from "./BuyerOrder.vue?vue&type=script&lang=js&"
export * from "./BuyerOrder.vue?vue&type=script&lang=js&"
import style1 from "../style.css?vue&type=style&index=1&id=47fdaace&prod&scoped=true&lang=css&"
import style2 from "./BuyerOrder.vue?vue&type=style&index=2&id=47fdaace&prod&scoped=true&lang=less&"
import style3 from "./BuyerOrder.vue?vue&type=style&index=3&id=47fdaace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fdaace",
  null
  
)

export default component.exports